import { ApiResponse, NoteType } from "../interfaces";

/**
 * Адаптер для вида сообщения
 */
class ColorMessageAdapter {

    /**
     * @param note_type
     * @param note_text
     */
    adapt({ note_type, note_text }: ApiResponse): { bsStyle: string, text: string } {
        let bsStyle;
        switch (note_type) {
            case 'error':
                bsStyle = 'danger';
                break;
            default:
                bsStyle = note_type
        }

        return {
            bsStyle,
            text: note_text,
        }
    }
}

export default ColorMessageAdapter;